import {Component} from '@angular/core';
import {CrudUserService} from '../../../../shared/services/crud-user.service';
import {UntypedFormBuilder} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {CrudEdit} from '../../../../shared/components/crud-edit';

@Component({
  selector: 'app-users-tools-edit-cavok',
  templateUrl: './users-tools-edit-cavok.component.html',
  styleUrls: ['./users-tools-edit-cavok.component.scss']
})
export class UsersToolsEditCavokComponent extends CrudEdit {

  constructor(protected httpcrud: CrudUserService, // Specific
              protected fb: UntypedFormBuilder,
              protected route: ActivatedRoute,
              protected router: Router) {
    super(httpcrud, fb, route, router);
  }

  initSpecificEditConfig() {
    // Specific
    this.entitylabelkey = 'username';
    this.redirecturl = '/admin/users';

    this.entityformconfig = [
      {
        field: 'active',
        fieldlabel: 'Active',
        fieldtype: 'checkbox',
        required: false
      },
      {
        field: 'first_name',
        fieldlabel: 'First name',
        fieldtype: 'text',
        required: true
      },
      {
        field: 'last_name',
        fieldlabel: 'Last name',
        fieldtype: 'text',
        required: true
      }
    ];

  } // initSpecificEditConfig

}
